import React from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import PageHeader from '../../Components/PageHeader'
import InfoCards from "./InfoCards"
import PageContentTable from "./PageContentTable"
import RecentActivity from "./RecentActivity"

export default function Dashboard() {
  return (

    <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">

      <Sidebar />

      {/* <!-- Main Content Area --> */}
      <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
        {/* <!-- Top Navigation Bar --> */}
        <TopHeader pageName="Content Management" />

        {/* <!-- Content Container --> */}
        <div id="content-container" className="flex-1 overflow-auto p-6">
          {/* <!-- Page Header --> */}
          <PageHeader />

          {/* <!-- Quick Stats --> */}
          {/* <InfoCards /> */}

          {/* <!-- Content Table --> */}
          <PageContentTable />

          {/* <!-- Recent Activity --> */}
          {/* <RecentActivity /> */}
        </div>
      </div>
    </div>
  )
}
